// extracted by mini-css-extract-plugin
export default {"chart-type-selector":"bf_N5"};